import { ref } from 'vue';
import { apiLink } from './apiLink'
import { deleteData, getData, postData, putData } from './generalio';
const personData = () => {
    const hostRoot = ref(apiLink)
    //const categories = ref([]) // if you just return the stuff - then its clearer - its a Promise thats returned
    const errorPerson = ref(null)
    
    const getCategories = (projectId) => {
        console.log('catdd')

        let endpoint = `categories/category/${projectId}`

        return getData(endpoint, "categories", [])
            .catch(err => {
                let msg = `ERROR fn: getCategories: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }

    const getPersons = (projectId) => {

        let endpoint = `person/${projectId}`

        return getData(endpoint, "person", [])
            .catch(err => {
                let msg = `ERROR fn: getPersons: ${err}`
                console.log(msg)
                throw Error(msg)
            })
    }  

    const updatePerson = (person, projectIn) => {

        let endPoint = `person/${projectIn}/${person.id}`

        return putData(endPoint, person, "person", -1)
            .then(r => {
                if (r != person.id) {
                    throw Error ('id returned from updatePerson is different than the one we wrote to' + JSON.stringify(r))
                }

                return r
            })
            .catch(err => {
                let msg = `ERROR fn: updatePerson: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }

    const createPerson =  (person, projectIn) => {
        
        delete person.id

        let endpoint = `person/${projectIn}`
        console.log('xxy',person)
        return postData(endpoint, person, "person", null)
            .then(r => {

                if (r != null && r != undefined) {
                    return r
                }
                //the stuff below should never happen - but lets put something here
                throw Error('person postData had bad data fed into the /person/{projectId} end point:' + JSON.stringify(r))
            })
            .catch(err => {
                let msg = `ERROR fn: createPerson: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }
    
    const deletePerson = (person, projectIn) => {

        let endpoint = `person/${projectIn}/${person.id}`

        return deleteData(endpoint, "person", -1)
            .then(r => {
                if (r != person.id) {
                    throw Error('id returned from deletePerson is different than the one we wrote to' + JSON.stringify(r))
                }
                return r
            })
            .catch(err => {
                let msg = `ERROR fn: deletePerson: ${err}`
                console.log(msg)
                throw Error(msg)
            })

    }

    const getWithErrors = (projectid) => {
        let endpoint = `person/${projectid}/errors`

        return getData(endpoint, 'person', -1)
        .then (r => {
            return r
        })
    }

    const getErrorCount = (projectid) => {
        let endpoint = `person/${projectid}/errorcount`

        return getData(endpoint, 'person', -1)
        .then (r => {
            return r
        })
    }
    
    return { getCategories, createPerson, getPersons, updatePerson, errorPerson, deletePerson, getWithErrors, getErrorCount }
}

export default (personData)
